import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import {ReactElement} from 'react';
import './MuiBaseModal.scss';
import {Grid, IconButton, Paper} from '@mui/material';
import {Close} from '@mui/icons-material';
import {FailureIcon, InfoIcon, SuccessIcon} from '../AnimatedIcons/AnimatedIcons';
import kaktusLoader from '../../assets/icons/kaktusLoader.svg';
import {useTranslation} from 'react-i18next';


type Props = {
  button?: ReactElement,
  open: boolean,
  onToggle: (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => void,
  content: ReactElement,
  header?: ReactElement,
  footer?: ReactElement,
  stage: BaseModalStage
  loadingMessageTitle?: string,
  loadingMessageSubtitle?: string,
  successMessageTitle?: string,
  successMessageSubtitle?: string,
  errorMessageTitle?: string,
  errorMessageSubtitle?: string,
  infoMessageTitle?: string,
  infoMessageSubtitle?: string,
  height: string
  width?: string
}

export type BaseModalStage = 'content' | 'loading' | 'success' | 'failure' | 'info'

export const MuiBaseModal = (props: Props) => {
  const headerAndFooterHeight = 0 + (!!props.header ? 80 : 0);
  const {t} = useTranslation('modals');

  const LoadingIcon = () => {
    return (
      <Typography variant='h3' component='h4'>
        <div className={'lds-eclipse'}>
          <img width={200} src={kaktusLoader} alt={'loader'} />
          <div />
        </div>
      </Typography>);
  };

  const status = (type: BaseModalStage) => {
    return (
      <Grid container justifyContent={'center'} height={'calc(100% - 60px)'}>
        <Grid item xs={12} justifyContent={'center'} display={'flex'} alignItems={'end'}>
          {type === 'success' && <SuccessIcon />}
          {type === 'failure' && <FailureIcon />}
          {type === 'loading' && <LoadingIcon />}
          {type === 'info' && <InfoIcon />}
        </Grid>
        <Grid item xs={12}>
          <Grid item xs={12} justifyContent={'center'} display={'flex'}>
            <Typography typography={'h6'}>
              {type === 'success' && props.successMessageTitle}
              {type === 'failure' && (props.errorMessageTitle || t('modals:default_error_message_title'))}
              {type === 'loading' && props.loadingMessageTitle}
              {type === 'info' && props.infoMessageTitle}
            </Typography>
          </Grid>
          <Grid item xs={12} justifyContent={'center'} display={'flex'}>
            <Typography typography={'body'}>
              {type === 'success' && props.successMessageSubtitle}
              {type === 'failure' && (props.errorMessageSubtitle || t('modals:default_error_message_subtitle'))}
              {type === 'loading' && props.loadingMessageSubtitle}
              {type === 'info' && props.infoMessageSubtitle}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      {props.button}
      <Modal
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
        open={props.open}
        onClose={props.onToggle}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{timeout: 500}}
      >
        <Fade in={props.open} timeout={250}>
          <div className={'mui-base-modal'} style={{height: props.height, width: props.width}}>
            <Paper className={'mui-base-modal-paper'}>
              <IconButton size={'small'} className={'close-mui-base-modal-button'} onClick={props.onToggle as any}>
                <Close />
              </IconButton>

              {props.header && <div className={'mui-base-modal-header'}>{props.header}</div>}

              <div className={'mui-base-modal-content'} style={{height: `calc(100% - ${headerAndFooterHeight}px)`, paddingBottom: 20}}>
                {props.stage === 'content' ? props.content : status(props.stage)}
              </div>
              {props.footer && <div className={'mui-base-modal-footer'}>{props.footer}</div>}

            </Paper>
          </div>
        </Fade>
      </Modal>
    </>
  );
};

